
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { User } from 'lucide-react';

interface EmptyPatientsStateProps {
  searchTerm: string;
}

const EmptyPatientsState: React.FC<EmptyPatientsStateProps> = ({ searchTerm }) => {
  return (
    <Card>
      <CardContent className="p-8 text-center">
        <User className="h-12 w-12 text-gray-400 mx-auto mb-4" />
        <p className="text-gray-500">
          {searchTerm 
            ? 'No patients found matching your search.' 
            : 'No patients yet. Add your first patient to get started.'
          }
        </p>
      </CardContent>
    </Card>
  );
};

export default EmptyPatientsState;
